(() => {
  if (window.mobileGlcMenuLoaded) {
    return;
  }

  window.mobileGlcMenuLoaded = true;

  const mobileMedia = window.matchMedia('(max-width: 999px)');
  let syncFrame;

  const getSidebar = () => document.querySelector('header-sidebar#sidebar-menu');

  const updateBackLabel = (sidebar, button) => {
    const language = button.querySelector('.glc-switcher-btn__language .glc-switcher-btn__name')?.textContent.trim();
    const currency = button.querySelector('.glc-switcher-btn__currency .glc-switcher-btn__name')?.textContent.trim();
    const label = sidebar.querySelector('[data-mobile-glc-back-label]');
    const values = [language, currency].filter(Boolean);

    const nextLabel = values.join(' / ');

    if (label && nextLabel && label.textContent.trim() !== nextLabel) {
      label.textContent = nextLabel;
    }
  };

  const closeThemePanel = (sidebar, revealMainPanel = true) => {
    const collapsiblePanel = sidebar.querySelector('header-sidebar-collapsible-panel');

    if (collapsiblePanel?.getAttribute('aria-activedescendant') === 'header-panel-localization') {
      collapsiblePanel.removeAttribute('aria-activedescendant');
    }

    sidebar.classList.remove('header-sidebar--glc-open');

    if (revealMainPanel) {
      sidebar.revealItems?.(true);
    }
  };

  const openThemePanel = (sidebar, sourceButton, appPanel) => {
    const panelSlot = sidebar.querySelector('[data-mobile-glc-panel-slot]');
    const collapsiblePanel = sidebar.querySelector('header-sidebar-collapsible-panel');

    if (!panelSlot || !collapsiblePanel) {
      return;
    }

    if (appPanel.parentElement !== panelSlot) {
      panelSlot.append(appPanel);
    }

    updateBackLabel(sidebar, sourceButton);
    sidebar.classList.add('header-sidebar--glc-open');
    collapsiblePanel.setAttribute('aria-activedescendant', 'header-panel-localization');
  };

  const sync = () => {
    syncFrame = undefined;

    if (!mobileMedia.matches) {
      return;
    }

    const sidebar = getSidebar();

    if (!sidebar) {
      return;
    }

    const sourceButton = sidebar.querySelector('.header-sidebar__linklist > .glc-switcher-btn--embedded-mobile');
    const buttonSlot = sidebar.querySelector('[data-mobile-glc-slot]');

    if (!sourceButton || !buttonSlot) {
      return;
    }

    let proxyButton = buttonSlot.querySelector('.header-sidebar__glc-proxy');

    if (!proxyButton) {
      proxyButton = document.createElement('div');
      proxyButton.className = 'header-sidebar__glc-proxy';
      proxyButton.setAttribute('aria-hidden', 'true');
      buttonSlot.append(proxyButton);
    }

    if (proxyButton.innerHTML !== sourceButton.innerHTML) {
      proxyButton.innerHTML = sourceButton.innerHTML;
    }

    updateBackLabel(sidebar, sourceButton);

    sourceButton.classList.add('header-sidebar__glc-source-overlay');

    if (sourceButton.dataset.mobileGlcMenuBound !== 'true') {
      sourceButton.dataset.mobileGlcMenuBound = 'true';
      sourceButton.addEventListener('click', settleSync);
      sourceButton.addEventListener('keydown', settleSync);
    }

    const proxyRect = proxyButton.getBoundingClientRect();

    if (proxyRect.width > 0 && proxyRect.height > 0) {
      sourceButton.style.setProperty('--mobile-glc-left', `${proxyRect.left}px`);
      sourceButton.style.setProperty('--mobile-glc-top', `${proxyRect.top}px`);
      sourceButton.style.setProperty('--mobile-glc-width', `${proxyRect.width}px`);
      sourceButton.style.setProperty('--mobile-glc-height', `${proxyRect.height}px`);

      const sourceRect = sourceButton.getBoundingClientRect();
      sourceButton.style.setProperty('--mobile-glc-left', `${proxyRect.left + proxyRect.left - sourceRect.left}px`);
      sourceButton.style.setProperty('--mobile-glc-top', `${proxyRect.top + proxyRect.top - sourceRect.top}px`);
    }

    const isOpen = sourceButton.classList.contains('glc-dropdown-btn__open') || sourceButton.getAttribute('aria-expanded') === 'true';
    const appPanel = document.querySelector('.glc-dropdown--default-embedded_menu.glc-dropdown-expand__active');

    if (isOpen && appPanel) {
      openThemePanel(sidebar, sourceButton, appPanel);
    } else if (!isOpen) {
      closeThemePanel(sidebar, sidebar.classList.contains('header-sidebar--glc-open'));
    }
  };

  const scheduleSync = () => {
    if (syncFrame) {
      return;
    }

    syncFrame = window.requestAnimationFrame(sync);
  };

  function settleSync() {
    [0, 50, 150, 300].forEach((delay) => window.setTimeout(scheduleSync, delay));
  }

  const start = () => {
    const sidebar = getSidebar();

    if (!sidebar) {
      return;
    }

    const backButton = sidebar.querySelector('[data-mobile-glc-back]');

    if (backButton && backButton.dataset.mobileGlcMenuBound !== 'true') {
      backButton.dataset.mobileGlcMenuBound = 'true';
      backButton.addEventListener('click', () => {
        closeThemePanel(sidebar);
        settleSync();
      });
    }

    if (sidebar.dataset.mobileGlcDrawerBound !== 'true') {
      sidebar.dataset.mobileGlcDrawerBound = 'true';
      sidebar.addEventListener('dialog:after-show', settleSync);
      sidebar.addEventListener('dialog:before-hide', () => {
        closeThemePanel(sidebar, false);
      });
    }

    const observer = new MutationObserver(scheduleSync);
    observer.observe(sidebar, { childList: true, subtree: true });
    observer.observe(document.body, { childList: true });
    mobileMedia.addEventListener('change', settleSync);
    settleSync();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
